import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { Provider } from 'react-redux'
import { store } from './redux/store.ts'
import { Toaster } from 'react-hot-toast'

import { ThemeProvider } from './components/theme-provider.tsx'

createRoot(document.getElementById('root')!).render(
  <Provider store={store}>
    <ThemeProvider defaultTheme='dark' storageKey='vite-ui-theme'>
      <Toaster position='top-right' reverseOrder={true} />
      <App />
    </ThemeProvider>
  </Provider>
)
